var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-block d-md-none mt-auto mx-auto mb-3",
      staticStyle: { "max-width": "400px" }
    },
    [
      _c(
        "div",
        { staticClass: "mx-auto mb-4 text-center" },
        _vm._l(_vm.showingServices, function(srvc) {
          return _c(
            "a",
            {
              key: srvc.name,
              staticClass: "d-inline-block mx-2",
              staticStyle: { height: "45px" },
              attrs: {
                href:
                  srvc.url +
                  "/?utm_source=accounts&utm_medium=logo&utm_term=" +
                  srvc.name +
                  "&utm_campaign=" +
                  _vm.utmCampaign,
                target: "_blank",
                "data-gtm-name":
                  _vm.utmCampaign === "login"
                    ? "login_service_links"
                    : "logout_service_link",
                "data-gtm-value-one": srvc.name,
                "data-gtm-value-two":
                  srvc.url +
                  "/?utm_source=accounts&utm_medium=logo&utm_term=" +
                  srvc.name +
                  "&utm_campaign=" +
                  _vm.utmCampaign
              }
            },
            [
              _c("img", {
                staticClass: "d-block h-100",
                attrs: {
                  src: _vm.platformLogos[srvc.name],
                  alt: srvc.name + " logo"
                }
              })
            ]
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          class: ["mx-auto text-center", { rtl: _vm.$i18n.locale === "fa" }],
          staticStyle: {
            "font-size": "13px",
            color: "#666",
            "margin-top": "10px",
            "line-height": "2"
          }
        },
        [
          _vm._v(
            "\n    " + _vm._s(_vm.$t("service_promotion_slogan.long")) + "\n  "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }